import { Api } from "./Api";
import Cookies from "js-cookie";

export const AuthApi = {
  async login(data: { email: string; password: string }) {
    try {
      const { data: response } = await Api.post(`/auth/login`, data);
      if (response.payload) {
        const token = response.payload.access_token;
        if (token) {
          Cookies.set("token", token, { secure: true, sameSite: "Strict" });
        }
      }
      return response;
    } catch (error) {
      return error;
    }
  },
  async googleLogin(googleCredential: string) {
    try {
      const { data: response } = await Api.post("/auth/google", {
        googleCredential,
      });
      if (response.payload) {
        const token = response.payload.access_token;
        if (token) {
          Cookies.set("token", token, { secure: true, sameSite: "Strict" });
        }
      }
      return response;
    } catch (error) {
      console.error("Error with Google login:", error);
    }
  },
  async forgottenPassword(email: string) {
    try {
      const { data: response } = await Api.post(`/auth/forgot-password`, {
        email,
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async resetPassword(data: { token: string; password: string }) {
    try {
      const { data: response } = await Api.post(`/auth/reset-password`, data);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async logout() {
    try {
      Cookies.remove("userId");
      Cookies.remove("token");
    } catch (error) {
      console.log(error);
    }
  },
};
